import React from "react";
import style from "./index.module.scss";
// import styled from "styled-components";

const App = props => {
  let { title, subtitle, bg, getData } = props
  return (
    <div className={style.solveContainer} style={{"background": `url(${bg}) no-repeat`,"backgroundSize":"cover"}}>
      <div className={`${style.content}`}>
        <div className={`${style.top}`}>
          <i></i>
          <span className={`${style.title}`}>{title}</span>
          <span className={`${style.subtitle}`}>{subtitle}</span>
          <i></i>
        </div>
        <div className={`${style.list}`}>
          {
            getData.data &&
            getData.data.data.map((item, index) => (
              <div key={index} className={`${style.listItem}`}>
                <img src={item.bg} alt=""/>
                <div className={`${style.itemInfo}`}>
                  <div className={`${style.itemTitle}`}>
                    <i style={{"background": `url(${item.icon}) no-repeat`,"backgroundSize":"cover"}}></i>
                    <span>{item.title}</span>
                  </div>
                  <div className={`${style.itemSubtitle}`}>{item.subtitle}</div>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
};

export default App;
